import makeStyles from '@mui/styles/makeStyles';

export const useLabelStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    maxHeight: theme.spacing(32.5),
    minHeight: theme.spacing(32.5),
    marginRight: theme.spacing(2)
  },
  typography: {
    color: theme.palette.text.secondary
  }
}));
